import {
    getPrice,
    listPrices
} from './queries';
import {
    createPrice,
    deletePrice,
    updatePrice,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';
import {Price} from "../types.ts";
import {generateClient} from "aws-amplify/api";


export type ListPrices = {
    listPrices: { items: Price[], nextToken?: string }
}

export type GetPrice = {
    getPrice: Price
}

export type CreatePrice = {
    createPrice: Price
}

export type UpdatePrice = {
    updatePrice: Price
}

export type DeletePrice = {
    deletePrice: string
}

const client = generateClient();


export const fetchRecords = async (filter: object, limit?: number, nextToken?: string) => {
    const response = await client.graphql<GraphQLQuery<ListPrices>>({
                                                                        query: listPrices,
                                                                        variables: {filter: filter, limit, nextToken},
                                                                    });
    return response.data?.listPrices;
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetPrice>>({
                                                                      query: getPrice,
                                                                      variables: {id: id},
                                                                  });
    return response.data?.getPrice;
};

export const add = async (payload: object) => {
    const response = await client.graphql<GraphQLQuery<CreatePrice>>({
                                                                         query: createPrice,
                                                                         variables: {input: payload},
                                                                     });
    return response.data?.createPrice;
};

// FNP-918 (§6): this function used to do `delete record.created` on the CALLER'S
// object — not a copy. That is the FNP-996 defect verbatim: it strips fields off
// the live Formik / React Query record, so the form the operator is looking at
// silently loses data the moment they hit save, and the cached row loses it too.
//
// The payload now arrives already WHITELISTED by `toPriceInput` in
// hooks/usePrice.ts, which is the single place that decision belongs.
export const update = async (_id: string, record: Price) => {
    const response = await client.graphql<GraphQLQuery<UpdatePrice>>({
                                                                         query: (updatePrice),
                                                                         variables: {input: record},
                                                                     });
    return response.data?.updatePrice;
};

export const deleteRecord = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<DeletePrice>>({
                                                                         query: (deletePrice),
                                                                         variables: {input: {id: id}},
                                                                     });
    return response.data?.deletePrice;
};
